import * as Routes from 'constants/Routes'
import { injectReducer } from 'common/reducers'

export default store => ({
  path: Routes.CERTIFICATIONS,
  getComponent: async function (nextState, cb) {
    const [module, reducer] = await Promise.all([
      import('./containers/CertificationsContainer'),
      import('./reducers')
    ])

    injectReducer(store, { key: 'certifications', reducer: reducer.default })

    cb(null, module.default)
  }
})
